import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

import { useGlobalToast } from "components/GlobalToastProvider";
import { getResendingLoginEmail, getResendLoginEmailError } from "selectors";

export const useResendLoginEmailToast = () => {
  const resendingLoginEmail = useSelector(getResendingLoginEmail);
  const resendLoginEmailError = useSelector(getResendLoginEmailError);
  const { showToast } = useGlobalToast();
  const prevResendingRef = useRef(false);

  useEffect(() => {
    if (prevResendingRef.current && !resendingLoginEmail) {
      if (resendLoginEmailError) {
        showToast({ message: "Failed to send login email", errorState: true });
      } else {
        showToast({ message: "Sent Successfully" });
      }
    }
    prevResendingRef.current = resendingLoginEmail ?? false;
  }, [resendingLoginEmail, resendLoginEmailError, showToast]);
};
